var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 896h-832C43.072 896 0 852.928 0 800v-576C0 171.072 43.072 128 96 128h832c52.928 0 96 43.072 96 96v576c0 52.928-43.072 96-96 96zM96 192a32 32 0 0 0-32 32v576a32 32 0 0 0 32 32h832c17.6 0 32-14.4 32-32v-576a32 32 0 0 0-32-32h-832z",
    fill: "#A594B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 557.312a31.872 31.872 0 0 1-17.728-5.376l-320-213.312a32 32 0 1 1 35.456-53.248L512 486.848l302.272-201.472a32 32 0 0 1 35.456 53.248l-320 213.312A31.36 31.36 0 0 1 512 557.312z",
    fill: "#A594B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.408d6e152a140c32ec9ad385225753da.svg";
export { ForwardRef as ReactComponent };